<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <div *ngIf="!enrolData?.image"
                        [class.initial-alpha]="!enrolData?.image"
                        class="users-avatar-shadow rounded mr-1 ml-0 bg-p bg-primary"
                      >
                        <div class="avatar-content">
                          {{enrolData?.name |titlecase| shortName}}
                        </div>
          </div>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{ enrolData?.name | titlecase}}</span>
              <!-- <span class="text-muted font-medium-1">
                <span>@</span>
                <span class="users-view-username">dean3004</span>
              </span> -->
            </h4>
            
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1"><i class="ft-book-open font-medium-3"></i></a>
          <a  class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1" (click)="setToEmp(enrolData?.user_id?._id)">Set To Employee </a>
          <a  class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1" (click)="openContentProjectAssign(myModalProjectAssign,enrolData._id,enrolData.project_assign)">Project Assign {{enrolData?.project_assign?1:0}}</a>
        <a  class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1" (click)="openContentAddFee(enrolData?._id)">Add Fees</a>
        <a [routerLink]="['/enrollments/edit', enrolData?._id]" class="btn btn-sm btn-primary px-3
          py-1">Edit</a>
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-12 users-module">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <!-- <th>Total Fee</th> -->
                          
                          <th>Net Fee</th>
                          <th>Total Paid</th>
                          <th>Paid Fee</th>
                          <th>Pending Fee</th>
                          <th>Mode</th>
                          <th>Status</th>
                          <th>Transaction Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let transaction of transactionData">
                                                  
                          <td>
                            <span>{{ enrolData?.net_fees |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span>{{ transaction?.total_paid |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span
                              class="badge bg-light-success"  placement="top"
                              ngbTooltip="{{transaction?.payment_notes}}">{{ transaction?.paid_amount |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span class="badge bg-light-danger" *ngIf="transaction?.pendingAmount !==null">{{ transaction?.pendingAmount |  currency:'INR':'symbol' }}</span>
                            <span class="badge bg-light-danger" *ngIf="transaction?.pendingAmount==null">{{0 |  currency:'INR':'symbol'}}</span>
                          </td>
                          <td>
                            <span>{{ transaction?.mode?.displayname }}</span>
                          </td>
                          <td>
                            <span *ngIf="transaction?.payment_status =='due'" class="badge bg-light-warn">{{ transaction?.payment_status }}</span>
                            <span *ngIf="transaction?.payment_status =='received'" class="badge bg-light-success">{{ transaction?.payment_status }}</span>

                          </td>
                          <td>
                            <span>{{ transaction?.updated_at | date :'mediumDate' }}</span>
                          </td>
                          <td>
                            <i class="ft-edit text-primary cursor-pointer mr-2" (click)="openContent(enrolData?._id,transaction?._id)"></i>
                            <i *ngIf="user_role.roles =='admin' || user_type == 'HR'" class="ft-trash-2 text-danger cursor-pointer" (click)="deleteTransaction(transaction?._id)"></i>
                          </td>
                        </tr>
                        <p *ngIf="transactionData.length<1" style="color:red">Data Not Found</p>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Card data ends -->
      </div>
      <div class="col-12">
        <!-- User detail starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row bg-primary bg-lighten-4 rounded mb-3 mx-1
                text-center text-md-left">
                <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                  <h6 class="primary align-self-center mb-0 mx-1">Registered:</h6>
                  <span class="font-large-1 primary">{{enrolData?.created_at | date :'shortDate'}}</span>
                  <span *ngIf="!enrolData?.created_at" class="font-large-1 primary">Data Not Found</span>
                </div>
                <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                  <h6 class="primary align-self-center mb-0 mx-1">Latest Activity:</h6>
                  <span class="font-large-1 primary">{{enrolData?.updated_at | date :'shortDate'}}</span>
                  <span class="font-large-1 primary" *ngIf="!enrolData?.updated_at">Data Not Found</span>
                </div>
                <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                  <h6 class="primary align-self-center mb-0 mx-1">Role:</h6>
                  <span class="font-large-1 primary">{{enrolData?.user_id?.roles}}</span>
                  <span class="font-large-1 primary" *ngIf="!enrolData?.user_id?.roles">Data Not Found</span>
                </div>
                <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                  <h6 class="primary align-self-center mb-0 mx-1">Status:</h6>
                  <span class=" font-large-1 badge bg-light-success users-view-status">{{enrolData?.status}}</span>
                  <span class="font-large-1 primary" *ngIf="!enrolData?.status">Data Not Found</span>
                </div>
                <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                  <h6 class="primary align-self-center mb-0 mx-1">Verified:</h6>
                  <span class="font-large-1 primary">Yes</span>                  
                </div>
              </div>
              <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                Enrollment Info</h5>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <!-- <tr>
                        <td>Username:</td>
                        <td class="users-view-username">dean3004</td>
                      </tr> -->
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-name">
                            <span>{{enrolData?.user_id?.name |titlecase}}</span>
                            <span *ngIf="!enrolData?.user_id?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>E-mail:</td>
                        <td>
                            <span>{{enrolData?.user_id?.email}}</span>
                            <span *ngIf="!enrolData?.user_id?.email">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Phone:</td>
                        <td>
                            <span>{{enrolData?.user_id?.phone}}</span>
                            <span *ngIf="!enrolData?.user_id?.phone">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Role:</td>
                        <td>
                            <span  class="badge bg-light-info">{{enrolData?.user_id?.roles}}</span>
                            <span *ngIf="!enrolData?.user_id?.roles">Data Not Found</span>
                        </td>
                      </tr>
                   
                      <tr>
                        <td>Documents Submitted: </td>
                        <td  [innerText]="enrolData?.notes"></td>
                        <td *ngIf="!enrolData?.notes">Data Not Found</td>
                      </tr>
                      <tr>
                        <td>Hunting By: </td>
                        <td>
                            <span>{{enrolData?.hunting_by?.name |titlecase}}</span>
                            <span *ngIf="!enrolData?.hunting_by?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Farming By: </td>
                        <td>
                            <span>{{enrolData?.farming_by?.name |titlecase}}</span>
                            <span *ngIf="!enrolData?.farming_by?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Goal: </td>
                        <td>
                            <span>{{enrolData?.goal?.displayname }}</span>
                            <span *ngIf="!enrolData?.goal?.displayname">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Notes: </td>
                        <td>
                        <span>{{enrolData?.admin_notes }}</span>
                        <span *ngIf="!enrolData?.admin_notes">Data Not Found</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h5 *ngIf="enrolData?.college?.name !=null" class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                    College Info</h5>
                  <div class="table-responsive" *ngIf="enrolData?.college?.name !=null">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>
                            <span>{{enrolData?.college?.name |titlecase}}</span>
                            <span *ngIf="!enrolData?.college?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <!-- <tr>
                          <td>email:</td>
                          <td>
                            <span>{{enrolData?.college?.email}}</span>
                            <span *ngIf="!enrolData?.college?.email">Data Not Found</span>
                          </td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                  <h5 *ngIf="enrolData?.course_id?.title !=null" class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                    Course Info</h5>
                  <div class="table-responsive" *ngIf="enrolData?.course_id?.title !=null">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>
                            <span>{{enrolData?.course_id?.title}}</span>
                            <span *ngIf="!enrolData?.course_id?.title">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Total Fee:</td>
                          <td>
                            <span>{{enrolData?.course_id?.total_fees}}</span>
                            <span *ngIf="!enrolData?.course_id?.total_fees">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                            <td>Announcements:</td>
                            <td>
                                <span>{{enrolData?.course_id?.announcements}}</span>
                                <span *ngIf="!enrolData?.course_id?.announcements">Data Not Found</span>
                            </td>
                          </tr>
                        <tr>
                            <td>About:</td>
                            <td [innerText]="enrolData?.course_id?.about"></td>
                            <td *ngIf="!enrolData?.course_id?.about">Data Not Found</td>
                        </tr>
                        <tr>
                            <td>Benifits:</td>
                            <td [innerText]="enrolData?.course_id?.benifits"></td>
                            <td *ngIf="!enrolData?.course_id?.benifits">Data Not Found</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5 *ngIf="enrolData?.batch_id" class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                    Batch Info</h5>
                  <div class="table-responsive" *ngIf="enrolData?.batch_id">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>
                            <span>{{enrolData?.batch_id?.name}}</span>
                            <span *ngIf="!enrolData?.batch_id?.name">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5 class="mb-2 text-bold-500" *ngIf="enrolData?.students"><i class="ft-info mr-2"></i>
                    Placement Info</h5>
                  <div class="table-responsive" *ngIf="enrolData?.students">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Placement Info:</td>
                          <td>
                            <span>{{enrolData?.students?.placementinfo}}</span>
                            <span *ngIf="!enrolData?.students?.placementinfo">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Placement business:</td>
                          <td>
                            <span>{{enrolData?.students?.placement_business?.name}}</span>
                            <span *ngIf="!enrolData?.students?.placement_business?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Bio:</td>
                          <td>
                            <span>{{enrolData?.students?.bio}}</span>
                            <span *ngIf="!enrolData?.students?.bio">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- User detail ends -->
      </div>
    </div>
    <div _ngcontent-fdm-c126="" class="buy-now">
      <a _ngcontent-fdm-c126=""   (click)="back()" class="btn btn-danger">Back To Enrolment</a>
    </div>
  </section>
  
<!------------- Project Assign Popup --------------------------------------->
<div>
	<ng-template #myModalProjectAssign>
	  <div class="modal-header">
		<h4 class="modal-title">Project Assign</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Projects</label>
				<ng-select
				[items]="project_list"
				bindLabel="name"
				bindValue="_id"
				[closeOnSelect]="false"
				placeholder="Select Project"
				[(ngModel)]="selected_project"
				[ngModelOptions]="{ standalone: true }"
				(change)="getProjectId($event)"
			  ></ng-select>
			</fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="projectAssign()">Submit</button>
	  </div>
	</ng-template>
</div>